import { Component } from '@angular/core';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { ConfigService } from '../../services/config/config.service';

@Component({
  selector: 'app-lost-and-found',
  templateUrl: './lost-and-found.component.html',
  styleUrls: ['./lost-and-found.component.scss'],
})
export class LostAndFoundComponent {
  isAuthenticated: boolean;

  public companyPhoneNumber = '';
  public companyMemberPhoneNumber = '';
  public brandName = '';

  constructor(
    public authManager: AuthManagerService,
    public userService: UserService,
    public configService: ConfigService,
  ) {
    this.isAuthenticated = authManager.isAuthenticated;
    this.companyPhoneNumber = configService.getTextFromKey('company-phone-number');
    this.companyMemberPhoneNumber = configService.getTextFromKey('phone-number-for-member');
    this.brandName = configService.getTextFromKey('brand-name');
  }
}
